/**
 * Lấy thông tin state của store: Manager Version
 * @param {*} state 
 * @returns 
 */
const getManagerVersionState = (state) => state['managerVersion']

export {
    getManagerVersionState
}